import * as React from 'react';

import * as styles from './MortgageSection.css';

export interface IMortgageSectionProps extends React.PropsWithChildren {
  tabs?: React.ReactNode;
  title: string;
}

export const MortgageSection: React.FC<IMortgageSectionProps> = ({ children, tabs }) => {
  return (
    <div className={styles['container']} data-testid="MortgageSection">
      {tabs && <div className={styles['tabs']}>{tabs}</div>}
      {children}
    </div>
  );
};
